const $ = require('jquery');
global.$ = global.jQuery = $;

$.migrateMute = true;
require('jquery-migrate');

const { Spinner } = require('spin.js');
global.Spinner = Spinner;

require('ace-builds/src-min-noconflict/ace');
require('ace-builds/src-min-noconflict/ext-language_tools');
require('ace-builds/webpack-resolver');

require('jquery.qrcode');

require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

require('select2/dist/css/select2.min.css');
require('select2');

const initializeSelect2 = function(root) {
    const elements = root.matches && root.matches('select')
        ? [root]
        : root.querySelectorAll('select');

    elements.forEach(function(element) {
        const select = $(element);
        if (select.hasClass('select2-hidden-accessible')) {
            return;
        }

        const modal = select.closest('.modal');
        select.select2({
            dropdownParent: modal.length ? modal : $(document.body),
            width: '100%'
        });
    });
};

$(function() {
    initializeSelect2(document);

    new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    initializeSelect2(node);
                }
            });
        });
    }).observe(document.body, { childList: true, subtree: true });
});

require('jquery-ui/themes/base/all.css');
require('jquery-ui/ui/position');
require('jquery-ui/ui/widget');
require('jquery-ui/ui/widgets/mouse');
require('jquery-ui/ui/widgets/resizable');
require('jquery-ui/ui/widgets/sortable');
require('jquery-ui/ui/widgets/tooltip');

require('ladda/dist/ladda-themeless.min.css');
const Ladda = require('ladda');
global.Ladda = Ladda;

const bootstrap = require('bootstrap');
global.bootstrap = bootstrap;

require('filepond/dist/filepond.min.css');
require('filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css');
const FilePondPluginImagePreview = require('filepond-plugin-image-preview/dist/filepond-plugin-image-preview');
const FilePondPluginFileValidateType = require('filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type');
const FilePondPluginFileValidateSize = require('filepond-plugin-file-validate-size/dist/filepond-plugin-file-validate-size');
const FilePond = require('filepond');
FilePond.registerPlugin(
    FilePondPluginImagePreview,
    FilePondPluginFileValidateType,
    FilePondPluginFileValidateSize
);
global.FilePond = FilePond;
const FilePondLocale_en = require('filepond/locale/en-en.js');
global.FilePondLocale_en = FilePondLocale_en.default;
const FilePondLocale_ja = require('filepond/locale/ja-ja.js');
global.FilePondLocale_ja = FilePondLocale_ja.default;
